import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getwebsiteProduct = createAsyncThunk("product/get-product", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/products/api/v1/get-product`, data, {
      headers: {
        "auth-token": token,
      },
    });
    // console.log("response web data get product", response);
    return response;
  } catch (error) {
    console.error("Error fetching product - ", error);
    throw error;
  }
});

export const getSingleProduct = createAsyncThunk("client/get-product-byid", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.get(`${baseUrl}vancouverapis/webapp/products/api/v1/get-product-byid/${data}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    // console.log("product single response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

//  get product price by unice id
export const getProductPriceByUniceId = createAsyncThunk("client/get-product-prices", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}vancouverapis/admin/productPrice/api/v1/uniqueId-productPrice/${data}`, {
      headers: {
        "auth-token": token,
      },
    });
    // console.log("response web data get product", response);
    return response;
  } catch (error) {
    console.error("Error fetching product - ", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
